import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { useHistory } from 'react-router-dom';
import {
  setExchEvent,
  setEventType,
  setCompetition,
  fetchCompetitions,
  fetchEventsByCompetition,
} from '../../store';
import { SelectedObj } from '../../models/ExchangeSportsState';
import {
  TableContainer,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  Paper,
  Accordion,
  AccordionDetails,
  AccordionSummary,
} from '@material-ui/core';
import './ExchEventsTable.scss';
import { IonCol, IonImg, IonRow } from '@ionic/react';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';

import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import { RootState } from '../../models/RootState';
import ExchOddBtn from '../ExchOddButton/ExchOddButton';
// import ExchBetslip from '../ExchBetslip/ExchBetslip';
import { formatDate, liveImagesMap } from '../../util/stringUtil';
import CricketImg from '../../assets/images/sportsbook/cricket-inplay.png';
import FootBallImg from '../../assets/images/sportsbook/football-inplay.png';
import TennisImg from '../../assets/images/sportsbook/tennis-inplay.png';
import HorseImg from '../../assets/images/sportsbook/horse.svg';
import ExchMobOddView from '../ExchOddButton/ExchMobOddView';
import {
  disconnectToWS,
  isConnected,
  subscribeWsForEventOdds,
  // unsubscribeAllWsforEvents,
} from '../../webSocket/webSocket';
import { EventDTO } from '../../models/common/EventDTO';
import HomeView from '../../constants/HomeView';
import { getSportLangKeyByName } from '../../util/localizationUtil';
import moment from 'moment';

type InplayEventsObj = {
  sportId: string;
  sportName: string;
  sportSlug: string;
  events: EventDTO[];
};

type StoreProps = {
  allowedConfig: number;
  inplayEvents: InplayEventsObj[];
  setEventType: (event: SelectedObj) => void;
  setCompetition: (event: SelectedObj) => void;
  setExchEvent: (event: SelectedObj) => void;
  fetchCompetitions: (eventTypeId: string) => void;
  fetchEventsByCompetition: (
    eventTypeId: string,
    competitionId: string
  ) => string;
  // addExchangeBet: (data: BsData) => void;
  // bets: BsData[];
  fetchingEvents: boolean;
  loggedIn: boolean;
  topicUrls: any;
  langData:any;
};

const InplayEventsTable: React.FC<StoreProps> = (props) => {
  const {
    allowedConfig,
    inplayEvents,
    setEventType,
    setCompetition,
    setExchEvent,
    fetchCompetitions,
    fetchEventsByCompetition,
    // addExchangeBet,
    // bets,
    fetchingEvents,
    loggedIn,
    topicUrls,
    langData
  } = props;
  const history = useHistory();
  const teamTypes = ['home', 'draw', 'away'];
  // const [openBetslip, setOpenBetslip] = useState<boolean>(true);
  const [wsChannels, setWsChannels] = useState<string[]>([]);
  const [matchOddsBaseUrl, setMatchOddsBaseUrl] = useState<string>('');
  const [matchOddsTopic, setMatchOddsTopic] = useState<string>('');

  const Images = HomeView.EVENT_PAGE_IMAGES;

  const tableFields = [
    {
      key: 'schedle',
      Label: langData?.['schedule'],
      className: 'schedule-cell schedule-cell-header',
      align: 'left',
    },
    { key: 'teams', Label: langData?.['teams'], className: 'teams-cell', align: 'left' },
    // { key: 'score', Label: 'Score', className: 'score-cell', align: 'center' },
    {
      key: 'homeTeamOdds',
      Label: '1',
      className: 'odds-cell-head',
      align: 'center',
      colSpan: 2,
    },
    {
      key: 'drawOdds',
      Label: 'X',
      className: 'odds-cell-head',
      align: 'center',
      colSpan: 2,
    },
    {
      key: 'awayTeamOdds',
      Label: '2',
      className: 'odds-cell-head',
      align: 'center',
      colSpan: 2,
    },
    {
      key: 'more',
      Label: '',
      className: 'all-markets-link-cell',
      align: 'center',
    },
  ];
  const getOdds = (eventData: EventDTO, teamType: string) => {
    const team =
      teamType === 'home'
        ? eventData.homeTeam
        : teamType === 'away'
          ? eventData.awayTeam
          : teamType;

    for (let runner of eventData.matchOdds.runners) {
      if (
        runner.runnerName.toLowerCase() === team.toLowerCase() ||
        runner.runnerName.toLowerCase().includes(team.toLowerCase())
      ) {
        return [
          {
            type: 'back-odd',
            price: runner?.backPrices[0]?.price,
            size: runner.backPrices[0]?.size,
            outcomeId: runner?.runnerId,
            outcomeName: runner.runnerName,
          },
          {
            type: 'lay-odd',
            price: runner?.layPrices[0]?.price,
            size: runner?.layPrices[0]?.size,
            outcomeId: runner.runnerId,
            outcomeName: runner.runnerName,
          },
        ];
      }
    }
    return null;
  };

  const handleEventChange = (iEvent: InplayEventsObj, event: EventDTO) => {
    const competitionSlug = event.competitionName
      ? event.competitionName
      : 'league'
          .toLocaleLowerCase()
          .replace(/[^a-z0-9]/g, ' ')
          .replace(/ +/g, ' ')
          .trim()
          .split(' ')
          .join('-');
    setEventType({
      id: iEvent.sportId,
      name: iEvent.sportName,
      slug: iEvent.sportSlug,
    });
    fetchCompetitions(iEvent.sportId);
    setCompetition({
      id: event.competitionId,
      name: event.competitionName,
      slug: competitionSlug,
    });
    fetchEventsByCompetition(iEvent.sportId, event.competitionId);
    setExchEvent({
      id: event.eventId,
      name: event.eventName,
      slug: event.eventSlug,
    });
    history.push(
      `/exchange_sports/${iEvent.sportSlug}/${competitionSlug}/${
        event.eventSlug
      }/${btoa(`${event.sportId}:${event.competitionId}:${event.eventId}`)}`
    );
  };

  const updateMatchOddsTopic = (
    currentTopic: string,
    currentBaseUrl: string
  ) => {
    if (
      matchOddsTopic !== currentTopic ||
      matchOddsBaseUrl !== currentBaseUrl
    ) {
      disconnectToWS();
      setMatchOddsTopic(currentTopic);
      setMatchOddsBaseUrl(currentBaseUrl);
    }
  };

  useEffect(() => {
    if (loggedIn && inplayEvents.length > 0 && topicUrls?.matchOddsTopic) {
      for (let iEvent of inplayEvents) {
        const subs = [...wsChannels];
        updateMatchOddsTopic(
          topicUrls?.matchOddsTopic,
          topicUrls?.matchOddsBaseUrl
        );
        for (let sEvent of iEvent.events) {
          if (!subs.includes(sEvent.eventId + sEvent.marketId)) {
            subs.push(sEvent.eventId + sEvent.marketId);
            subscribeWsForEventOdds(
              topicUrls?.matchOddsTopic,
              sEvent.sportId,
              sEvent.competitionId,
              sEvent.eventId,
              sEvent.matchOdds?.marketId
            );
          }
        }
        setWsChannels(subs);
      }
    }
  }, [isConnected(), inplayEvents, loggedIn]);

  return (
    <div className="events-table-ctn">
      <div className="banner-container inplay-bg">
        <img
          className="banner-image"
          src={Images['inplay']?.image}
          key={'inplay-image'}
          alt={'banner'}
          title={'In Play'}
        />
      </div>

      {inplayEvents ? (
        inplayEvents.length > 0 && 
        (inplayEvents
          // .filter((event) => Number(event?.sportId))
          .filter(
            (event) => event.events.filter((ev) => ev.status === "IN_PLAY").length > 0
          ).length > 0) ? (
          inplayEvents.map((iEvent, inpIdx) => (
            <>
              {(allowedConfig & Number(iEvent.sportId)) !== 0 ? (
                <Accordion
                  className="eventType-accordion"
                  defaultExpanded={true}
                >
                  <AccordionSummary
                    expandIcon={<ExpandMoreIcon className="expand-icon" />}
                    aria-controls="panel1a-content"
                    className="eventType-header"
                  >
                    <IonImg
                      className="sport-inplay-icon"
                      src={
                        iEvent.sportId === '1'
                          ? FootBallImg
                          : iEvent.sportId === '2'
                          ? TennisImg
                          : iEvent.sportId === '77'
                          ? HorseImg
                          : CricketImg
                      }
                    />
                  {langData?.[`${getSportLangKeyByName(iEvent.sportName)}`]}
                  </AccordionSummary>

                  <AccordionDetails className="inplay-events-tbl-container">
                    <div className="events-table-content table-ctn">
                      <TableContainer component={Paper}>
                        <Table className="events-table inplay-table">
                          <TableHead>
                            <TableRow>
                              {tableFields.map((tF, index) => (
                                <TableCell
                                  key={tF.key + index}
                                  align={
                                    tF.align === 'left' ? 'left' : 'center'
                                  }
                                  colSpan={tF.colSpan ? tF.colSpan : 1}
                                  className={tF.className}
                                >
                                  {tF.Label}
                                </TableCell>
                              ))}
                            </TableRow>
                          </TableHead>
                          <TableBody>
                            {iEvent?.events.filter((s) => new Date(s.openDate).getTime() <= moment().valueOf()).map((sEvent, idx) => (
                              <TableRow>
                                <TableCell className="schedule-cell">
                                  {formatDate(sEvent?.openDate)}
                                </TableCell>
                                <TableCell className="teams-cell">
                                  <div
                                    className="all-markets-nav-link"
                                    key={'all-markets-link'}
                                    onClick={() =>
                                      handleEventChange(iEvent, sEvent)
                                    }
                                  >
                                    {sEvent?.homeTeam !== '' &&
                                    sEvent?.awayTeam !== '' ? (
                                      <>
                                        <div className="web-view">
                                          <div className="temas-col">
                                            <div className="teams">
                                              <div className="team-name">
                                                {sEvent.homeTeam}
                                              </div>
                                              <div className="team-name">
                                                {sEvent.awayTeam}
                                              </div>
                                            </div>

                                            {sEvent.inPlay ||
                                            sEvent.status === 'IN_PLAY' ? (
                                              <img
                                                className="live-img"
                                                src={
                                                  liveImagesMap[sEvent.sportId]
                                                }
                                                alt="live"
                                              />
                                            ) : null}
                                          </div>
                                        </div>
                                        <div className="mob-view">
                                          <div className="event-name">
                                            {sEvent.eventName}

                                            {sEvent.inPlay ||
                                            sEvent.status === 'IN_PLAY' ? (
                                              <img
                                                className="live-img"
                                                src={
                                                  liveImagesMap[sEvent.sportId]
                                                }
                                                alt="live"
                                              />
                                            ) : null}
                                          </div>
                                          <div className="schedule-time">
                                            {formatDate(sEvent.openDate)}
                                          </div>
                                        </div>
                                      </>
                                    ) : (
                                      <div className="team-name">
                                        {sEvent.eventName}
                                      </div>
                                    )}
                                    <IonRow className="mob-odds-row">
                                      {teamTypes.map((teamType, index) => (
                                        <IonCol
                                          className="mob-odds-block"
                                          key={teamType + index}
                                        >
                                          {sEvent.matchOdds ? (
                                            getOdds(sEvent, teamType) ? (
                                              <>
                                                {getOdds(sEvent, teamType).map(
                                                  (odd) => (
                                                    <ExchMobOddView
                                                      mainValue={odd.price}
                                                      disable={sEvent.matchOdds.status
                                                        .toLowerCase()
                                                        .includes('suspended')}
                                                      oddType={
                                                        odd.type === 'back-odd'
                                                          ? 'back-odd'
                                                          : 'lay-odd'
                                                      }
                                                    />
                                                  )
                                                )}
                                              </>
                                            ) : (
                                              <>
                                                <ExchMobOddView
                                                  mainValue={null}
                                                  oddType="back-odd"
                                                />
                                                <ExchMobOddView
                                                  mainValue={null}
                                                  oddType="lay-odd"
                                                />
                                              </>
                                            )
                                          ) : (
                                            <>
                                              <ExchMobOddView
                                                mainValue={null}
                                                oddType="back-odd"
                                              />
                                              <ExchMobOddView
                                                mainValue={null}
                                                oddType="lay-odd"
                                              />
                                            </>
                                          )}
                                        </IonCol>
                                      ))}
                                    </IonRow>
                                  </div>
                                </TableCell>
                                {/* <TableCell className="score-cell" align="center">
                              <div className="score">0</div>
                              <div className="score">0</div>
                            </TableCell> */}
                                {teamTypes.map((teamType, index) => (
                                  <TableCell
                                    className="odds-cell"
                                    align="center"
                                    colSpan={2}
                                    key={teamType + index}
                                  >
                                    {sEvent?.matchOdds ? (
                                      getOdds(sEvent, teamType) ? (
                                        <div className="odds-block">
                                          {getOdds(sEvent, teamType).map(
                                            (odd) => (
                                              <ExchOddBtn
                                                mainValue={odd.price}
                                                subValue={odd.size}
                                                oddType={
                                                  odd.type === 'back-odd'
                                                    ? 'back-odd'
                                                    : 'lay-odd'
                                                }
                                                disable={sEvent.matchOdds.status
                                                  .toLowerCase()
                                                  .includes('suspended')}
                                                valueType="matchOdds"
                                                showSubValueinKformat={true}
                                                onClick={() => null}
                                              />
                                            )
                                          )}
                                        </div>
                                      ) : (
                                        <EmptyOddsBlock />
                                      )
                                    ) : (
                                      <EmptyOddsBlock />
                                    )}
                                  </TableCell>
                                ))}
                                <TableCell
                                  className="all-markets-link-cell"
                                  align="right"
                                >
                                  <div
                                    className="all-markets-nav-link"
                                    key={'all-markets-link'}
                                    onClick={() =>
                                      handleEventChange(iEvent, sEvent)
                                    }
                                  >
                                    <ChevronRightIcon />
                                  </div>
                                </TableCell>
                              </TableRow>
                            ))}
                          </TableBody>
                        </Table>
                      </TableContainer>
                    </div>
                  </AccordionDetails>
                </Accordion>
              ) : null}
            </>
          ))
        ) : !fetchingEvents ? (
          <div className="events-table-msg-text">No Inplay Events</div>
        ) : null
      ) : null}
      {/* <Accordion
        className="bs-accordion"
        expanded={openBetslip}
        onChange={(_, expanded) => setOpenBetslip(expanded)}
      >
        <AccordionSummary
          expandIcon={<ExpandMoreIcon className="expand-icon" />}
          aria-controls="panel1a-content"
          className="bs-header"
        >
          Bet Slip ({bets.length})
        </AccordionSummary>
        <AccordionDetails className="bs-body">
          {bets.length > 0 ? <ExchBetslip /> : null}
        </AccordionDetails>
      </Accordion> */}
    </div>
  );
};

function EmptyOddsBlock() {
  return (
    <React.Fragment>
      <div className="odds-block">
        <ExchOddBtn mainValue={null} oddType="back-odd" />
        <ExchOddBtn mainValue={null} oddType="lay-odd" />
      </div>
    </React.Fragment>
  );
}

const mapStateToProps = (state: RootState) => {
  return {
    // bets: state.exchBetslip.bets,
    allowedConfig: state.common.allowedConfig,
    loggedIn: state.auth.loggedIn,
    fetchingEvents: state.exchangeSports.fetchingEvents,
    topicUrls: state?.exchangeSports?.topicUrls,
    langData:state.common.langData,
  };
};

const mapDispatchToProps = (dispatch: Function) => {
  return {
    setEventType: (eType: SelectedObj) => dispatch(setEventType(eType)),
    setCompetition: (competition: SelectedObj) =>
      dispatch(setCompetition(competition)),
    setExchEvent: (event: SelectedObj) => dispatch(setExchEvent(event)),
    fetchCompetitions: (eventTypeId: string) =>
      dispatch(fetchCompetitions(eventTypeId)),
    fetchEventsByCompetition: (etId: string, cId: string) =>
      dispatch(fetchEventsByCompetition(etId, cId, [])),
    // addExchangeBet: (data: BsData) => dispatch(addExchangeBet(data)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(InplayEventsTable);
